import React from 'react';
import PropTypes from 'prop-types';
import { AmplifyGrid, AmplifyGridRow } from '@amplify/amplify-grid';
import { CELL_MEASUREMENTS, INDEX } from '../../../constants/shared/CellConstants';
import { getRowsToRender } from '../../../utils/shared/dualLanguageUtils';
import './SkillsTable.scss';
import { generateReactKey } from '../../../utils/shared/commonUtils';

const CELL_STYLES = {
    ':focus': { outline: 'none' },
    outline: 'none',
};
const gridProps = {
    defaultCellMeasurements: CELL_MEASUREMENTS.DEFAULT_BENCHMARK,
    cssString: 'height: 310px',
    stickyColumnList: [INDEX.FIRST_ARRAY_INDEX],
    gridHeaderStyles: CELL_STYLES,
    subHeaderStyles: {},
    dataCellStyles: CELL_STYLES,
};

const SkillsTable = ({ skills, results }) => {
    const rows = getRowsToRender(skills, results);

    return (
        <section className="skills-table">
            <AmplifyGrid {...gridProps}>
                {rows.map((row, index) => {
                    return (
                        <AmplifyGridRow
                            key={generateReactKey(index)}
                            {...row.rowProperties}
                            rowObject={row.rowObject}
                        />
                    );
                })}
            </AmplifyGrid>
        </section>
    );
};

SkillsTable.defaultProps = {
    skills: [],
    results: {},
};

SkillsTable.propTypes = {
    skills: PropTypes.array,
    results: PropTypes.object,
};

export default SkillsTable;
